
import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectSubmitForm$ = new BehaviorSubject({});

export const behaviorSubjectSubmitForm = behaviorSubjectSubmitForm$.asObservable();